import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import IN from './Components/IN/IN';
import TE from './Components/TE/TE';
import SE from './Components/SE/SE';
import NonSEButtons from './Components/ButtonArea/NonSE';
import SEButtons from './Components/ButtonArea/SE';
import CBModal from './Components/IN/CustomFields/Checkbox/Modal/Modal';
import SmsVercode from './Components/IN/ProfileFields/SmsVercode';
import { setFv } from '/src/Redux/actions';
import { loadLiff } from '/src/Util/Liff';

const App = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {page_type, csrf_token, acct_id, funnel_page_id, hook_status, preview, sl, internaltest} = props;
	const [formFields, setFormFields] = useState({
		user_data: {},
		funnel_page: {},
		profile_fields: {},
		form_components: [],
		num_se: 0
	});

	const lineUserData = useSelector(state => state.lineUserData);

	useEffect(() => {
		// Wait for i18n to be initialized before changing language
		i18n.changeLanguage(props.lang);

		const payload = {
			csrf_token: csrf_token,
			acct_id: acct_id,
			funnel_page_id: funnel_page_id,
			hook_status: hook_status,
			preview: preview,
			internaltest: internaltest
		}

		dispatch({type: 'SET_PAGE_DATA', payload: payload});
		loadData();

		if (!preview) {
			loadLiff(dispatch, csrf_token, page_type, funnel_page_id, null, sl, preview);
		}
	}, []);

	async function loadData() {
		try {
			const response = await axios.get(`/FormComponents/ajaxGetData/${page_type}/${acct_id}/${funnel_page_id}`);

			setFormFields(prevData => ({
				...prevData,
				funnel_page: response.data.funnel_page,
				profile_fields: response.data.profile_fields,
				form_components: response.data.form_components,
				num_se: response.data.num_se
			}));

			const form_components = response.data.form_components;

			dispatch(setFv(response.data.num_se, hook_status));

			const user_data = response.data.user_data;
			dispatch({type: 'SET_USER_DATA', payload: user_data});

			dispatch({type: 'SET_CONTACT_FIELD', payload: {
				field: 'email',
				value: user_data ? user_data.email : ''
			}});

			dispatch({type: 'SET_CONTACT_FIELD', payload: {
				field: 'country_code',
				value: user_data ? user_data.country_code : ''
			}});

			dispatch({type: 'SET_CONTACT_FIELD', payload: {
				field: 'mobile',
				value: user_data ? user_data.mobile : ''
			}});

			const optionFields = [];
			let currentSEIndex = 0;
			form_components.forEach(form_component => {
				if (form_component.format === 'SE') {
					currentSEIndex++;
				}
				if (['select', 'radio', 'checkbox'].includes(form_component.input_type)) {
					const existingValue = user_data ? user_data[form_component.fieldname] : '';
					optionFields.push({
						fieldname: form_component.fieldname,
						value: existingValue || '',
						seq: form_component.seq
					});
				}
			});
			
			if (optionFields.length > 0) {
				console.log('optionFields after loadData', optionFields);
				dispatch({type: 'SET_OPTION_FIELDS', payload: optionFields});
			}
		} catch (e) {
			console.error(e);
		}
	}

	return (
		<>
		<input type="hidden" name="recaptcha_response" id="recaptcha-response" />
		<input type="hidden" name="line[user_id]" value={lineUserData.userId} />
		<input type="hidden" name="line[follow]" value={lineUserData.follow ? 1 : 0} />
		<input type="hidden" name="line[email]" value={lineUserData.email} />
		<input type="hidden" name="line[nickname]" value={lineUserData.nickname} />
		<div className="merge-form">
			{(() => {
				const components = [];
				let currentSEDiv = null;
				let se_count = 0, in_count = 0;

				formFields.form_components.forEach((form_component, index) => {
					switch (form_component.format) {
						case 'SE':
							// Close the previous SE div if it exists
							if (currentSEDiv) {
								components.push(currentSEDiv);
							}

							// Start a new SE component
							se_count++;
							const div_class = se_count === 1 ? 'js-step js-step-active' : 'js-step';
							//console.log(`content`, form_component.content);

							currentSEDiv = (
								<SE
									key={`step-${se_count}`}
									lang={props.lang}
									formFields={formFields}
                                    se_count={se_count}
                                    form_component={form_component}
								>
									{[]}
								</SE>
							);
							break;

						case 'IN':
						case 'TE':
							if (form_component.format === 'IN') {
								++in_count;
							}

							// If no SE component exists, create a default container
							if (!currentSEDiv) {
								currentSEDiv = (
									<div className="default-container" key="default-container">
										<div className="quest_list tab-on">
											<p className="guide">Default Section</p>
										</div>
									</div>
								);
							}
							//console.log(`currentSEDiv`, currentSEDiv);

							// Ensure children is an array
							const childrenArray = React.Children.toArray(currentSEDiv.props.children);

							// Add IN and TE components to the current SE component
							switch (form_component.format) {
								case 'IN':
									currentSEDiv = React.cloneElement(
										currentSEDiv,
										{},
										[
											...childrenArray,
											<IN
												key={`in-${index}`}
												lang={props.lang}
												formFields={formFields}
												setFormFields={setFormFields}
												form_component={form_component}
												count={in_count}
											/>
										]
									);
									break;

								case "TE":
									currentSEDiv = React.cloneElement(
										currentSEDiv,
										{},
										[
											...childrenArray,
											<TE
												key={`te-${index}`}
												lang={props.lang}
												formFields={formFields}
												setFormFields={setFormFields}
												form_component={form_component}
											/>
										]
									);
									break;
							}
							
							//console.log(`currentSEDiv after`, currentSEDiv);
							break;
					}
				});

				// Push the last SE component or default container if it exists
				if (currentSEDiv) {
					components.push(currentSEDiv);
				}

				formFields.form_components.forEach((form_component, index) => {
					if (form_component.fieldname === 'mobile' && form_component.sms_vercode) {
						components.push(
							<SmsVercode
								lang={props.lang}
								formFields={formFields}
								form_component={form_component}
							/>
						);
					}
				});

				return components;
			})()}
		</div>
		{formFields.num_se <= 1 ? (
			<NonSEButtons
				lang={props.lang}
				formFields={formFields}
			/>
		) : (
			<SEButtons
				lang={props.lang}
				formFields={formFields}
			/>
		)}
		<CBModal
			lang={props.lang}
		/>
		</>
	);
}

export default App;